// extracted by mini-css-extract-plugin
export default {"timeline":"About_timeline__We+sr","title":"About_title__pZpnC"};